import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  fetchSetReviewReactionWeb,
  TSetReviewReactionWebResponse,
} from '../../repositories/newbuilding-reviews/v1/set-review-reaction-web';

import { TThunkAction } from '../../types/redux/thunk';

import { TLikeStatus } from '../../types/developerV2/review';
import { setReviewReactionAction } from './actions';
import { EType } from '../../repositories/newbuilding-reviews/entities/set_review_reaction/SetReviewReactionRequest';

interface IParams {
  reviewId: string;
  type: TLikeStatus;
}

export const setReviewReaction = ({ reviewId, type }: IParams): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { logger, httpApi } = context;

    try {
      const { response, statusCode }: TSetReviewReactionWebResponse = await fetchSetReviewReactionWeb({
        httpApi,
        parameters: { reviewId, type: type as EType },
      });

      if (statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          statusCode,
          message: 'Ошибка запроса на изменение реакции',
          domain: 'src/browser/services/reviews/setReviewReaction.ts',
        });
      }

      dispatch(setReviewReactionAction({ reviewId, type: response.type }));
    } catch (error) {
      logger.error(error, {
        domain: 'setReviewReaction',
        message: error.message,
      });
    }
  };
};
